import { render, staticRenderFns } from "./QuotationForm.vue?vue&type=template&id=2fff4bbc&scoped=true&"
import script from "./QuotationForm.vue?vue&type=script&lang=js&"
export * from "./QuotationForm.vue?vue&type=script&lang=js&"
import style0 from "./QuotationForm.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./QuotationForm.vue?vue&type=style&index=1&id=2fff4bbc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fff4bbc",
  null
  
)

export default component.exports